class ErrorUtils {

    static handleUnauthorized(error) {
        if (401 === error.response?.status) {
            window.location.href = '/login';
        }
    }

    static toMessage(error, skipRedirect) {
        if (!skipRedirect) {
            this.handleUnauthorized(error);
        }

        const request = error.request;
        const response = error.response;
        let errorData = response?.data;

        if (this.isBlobError(request, errorData)) {
            return this.getBlobError(errorData);
        }

        if (401 === response?.status || 400 === response?.status && errorData?.detail) {
            return errorData?.detail;
        }

        if (errorData?.errors) {
            return errorData.errors?.map(error => error).join('\n') || errorData.message || errorData;
        }

        if (errorData?.detail) {
            return errorData.detail;
        }

        return "Erro de rede.";
    }

    static async getBlobError(errorMessage) {
        const text = await errorMessage.text();
        errorMessage = errorMessage.type.toLowerCase().includes('json') ? JSON.parse(text) : text;
        return errorMessage.errors?.map(error => error).join('\r') || errorMessage.message || errorMessage;
    }

    static isBlobError(request, errorMessage) {
        return 'blob' === request?.responseType && errorMessage instanceof Blob && errorMessage?.type;
    }

    static error(toast, message) {
        if (!toast) {
            return;
        }
        toast.add(this.toastMessage('error', 'Erro', message));
    }

    static toastMessage(severity, summary, message) {
        return {severity: severity, summary: summary, detail: message, life: 5000};
    }
}

export default ErrorUtils;